import { Box, LinearProgress, linearProgressClasses, styled, Typography } from '@mui/material'

/**
 * Custom styled LinearProgress component with rounded borders.
 * Based on MUI documentation example:
 * @see https://mui.com/material-ui/react-progress/#customization
 */
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.secondary.main,
  },
}))

interface RestartProgressBarProps {
  progress: number
  statusText: string
}

export function RestartProgressBar({ progress, statusText }: Readonly<RestartProgressBarProps>) {
  return (
    <Box sx={{ mt: 2 }}>
      <BorderLinearProgress value={progress} variant="determinate" />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1, pt: 0.5 }}>
        <Typography color="text.secondary" variant="caption">
          {statusText}
        </Typography>
        <Typography color="text.secondary" variant="caption">
          {progress}%
        </Typography>
      </Box>
    </Box>
  )
}
